import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import bg2 from '../../../assets/images/2.jpg'
import bg3 from '../../../assets/images/3.jpg'
import bg4 from '../../../assets/images/4.jpg'
import bg5 from '../../../assets/images/5.jpg'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';

import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

const PlayerSlider = () => {
    return (
        <div className="flex h-screen items-center justify-center ">
            <Swiper
                autoplay={true}
                effect='coverflow'
                grabCursor={true}
                centeredSlides={true}
                loop={true}
                slidesPerView={'auto'}
                coverflowEffect={
                    {
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2.5
                    }
                }
                pagination={{ el: '.swiper-pagination', clickable: true }}
                // navigation={
                //     {
                //         nextEl: 'swiper-button-next',
                //         prevEl: 'swiper-button-prev',
                //         clickable: true,
                //     }
                // }
                modules={[EffectCoverflow, Pagination, Navigation]}
                className='swiper-container'
            >
                <SwiperSlide> <img src={bg2} /> </SwiperSlide>
                <SwiperSlide> <img src={bg3} /> </SwiperSlide>
                <SwiperSlide> <img src={bg4} /> </SwiperSlide>
                <SwiperSlide> <img src={bg5} /> </SwiperSlide>
                {/* <div className='swiper-controler'>
                    <div className='swiper-button-prev slider-arrow'>
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <div className='swiper-button-next slider-arrow'>
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <div className='swiper-pagination'></div>
                </div> */}
            </Swiper>
        </div>
    );
};

export default PlayerSlider;